import { useEffect, useState } from "react";

import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Outlet } from "react-router-dom";

import { Theme } from "../../../Style/Theme";
import { NavigationContentDashboard } from "../../molecules/NavigationContent/NavigationContentDashboard";
import { SideNavigation } from "../../molecules/SideNavigation/SideNavigation";
import TopNavigationBar from "../../molecules/TopNavigationBar/TopNavigationBar";
import "./Dashboard.style.css";

export default function MainLayout() {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 990) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    });
  }, []);

  const drawerWidth = 200;
  const topNavigationBarHeight = "56px";

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={Theme}>
      <Box
        id="main"
        sx={{
          height: "100vh",
          display: "flex",
          backgroundColor: (theme) => theme.palette.background.offWhite,
        }}
      >
        <CssBaseline />
        <TopNavigationBar
          backgroundColor={"#FFF"}
          open={open}
          drawerWidth={"100%"}
          minHeight={topNavigationBarHeight}
        >
          <NavigationContentDashboard open={open} toggleDrawer={toggleDrawer} />
        </TopNavigationBar>
        <SideNavigation
          topNavigationBarHeight={topNavigationBarHeight}
          toggleDrawer={toggleDrawer}
          open={open}
          drawerWidth={drawerWidth}
        />
        <Box
          id="contain"
          sx={{
            backgroundColor: (theme) => theme.palette.background.offWhite,
            flexGrow: 1,
            width: "100%",
            overflow: "auto",
            padding: "25px 0",
            marginRight: "14px",
            marginLeft: "14px",
            marginTop: "56px",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
